import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import {
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  getCenterInfo,
  getCentreCampPackage,
  postCentreCampPackage,
  updateCentreCampPackage,
  getCampPackages,
} from "../../actions/GenomicsAdminAction";
import { TablePagination } from "@material-ui/core";
import moment from "moment";
import { Button } from "@material-ui/core";

import Loader from "../../Components/loader/index";
import Autocomplete from "@material-ui/lab/Autocomplete";

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "90%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      borderLeft: "solid 1px #0e416b",
      borderRight: "solid 1px #0e416b",
      borderBottom: "solid 1px #0e416b",
      marginTop: "20px",
      minHeight: "300px",
    },
    table: {
      minWidth: 700,
    },
    tableRow: {
      padding: "5px 0 5px 5px !important",
    },
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  loading: boolean;
  getCampPackages: any;
  campPackages: any;
  getCentreCampPackage: any;
  postCentreCampPackage: any;
  updateCentreCampPackage: any;
  centreCampPackage: any;
  getCenterInfo: any;
  centerInfo: any;
}

const CentreCampPackage: React.FC<Props> = ({
  loading,
  campPackages,
  getCampPackages,
  getCentreCampPackage,
  postCentreCampPackage,
  updateCentreCampPackage,
  centreCampPackage,
  getCenterInfo,
  centerInfo,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [page, setPage] = useState(0);

  const [startDate, setStartDate] = useState<any>("");

  const [endDate, setEndDate] = useState<any>("");

  const [center, setCenter] = useState<any>([]);
  const [centreType, setCentreType] = useState<any>("");
  const history = useHistory();

  const [packages, setPackages] = useState<any>("");
  useEffect(() => {
    getCentreCampPackage();
    getCampPackages();
    getCenterInfo();
  }, []);

  const dispatch = useDispatch();

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        centreCampPackage.links && centreCampPackage.links.next.split("?")[1];
      getCentreCampPackage(url);
    } else if (newPage < page) {
      let url =
        centreCampPackage.links &&
        centreCampPackage.links.previous.split("?")[1];
      getCentreCampPackage(url);
    }
    setPage(newPage);
  };
  const filterHandler = async (e: any) => {
    e.preventDefault();
    const data = {
      centrecamp: [
        {
          centers: center,
          package: packages,
          valid_from: startDate,
          valid_till: endDate,
        },
      ],
    };
    await postCentreCampPackage(data);
    getCentreCampPackage();
    history.push("/dashboard/gnadmin/centre_camp_package");
  };
  useEffect(() => {
    getCenterInfo(`?center_type=${centreType}`);
  }, [centreType]);

  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          <h4 style={{ fontWeight: "bold" }}>HOSPITAL CAMP PACKAGE</h4>
        </div>
        <form onSubmit={filterHandler} className={classes.contentFilter}>
          <Grid
            container
            spacing={3}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                select
                fullWidth
                variant="outlined"
                label="Centre Type"
                value={centreType}
                onChange={(e) => setCentreType(e.target.value)}
              >
                <MenuItem value="collection_center">Collection Center</MenuItem>
                <MenuItem value="direct_client">Direct Client</MenuItem>
                <MenuItem value="corporate">Corporate</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let packs: any = [];
                    newValue.map((val: any) => {
                      let obj = JSON.parse(JSON.stringify(val, null, " "));
                      packs.push(obj.id);
                    });
                    setCenter(packs);
                  }
                }}
                freeSolo
                multiple
                limitTags={1}
                blurOnSelect
                options={centerInfo.results}
                getOptionDisabled={(option: any) => {
                  return center.includes(option.id);
                }}
                disableClearable
                disableCloseOnSelect
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                aria-required
                onInputChange={(event, newInputValue) => {
                  getCenterInfo(
                    `?center_type=${centreType}&name_or_code=${newInputValue}`
                  );

                  if (newInputValue.length === 0) {
                    setCenter("");
                  } else if (centerInfo.results === 1) {
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    placeholder="Centre"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setPackages(obj.id);
                  }
                }}
                freeSolo
                blurOnSelect
                disabled={campPackages?.results === undefined}
                options={campPackages?.results || []}
                disableCloseOnSelect
                onInputChange={(event, newInputValue) => {
                  setTimeout(getCampPackages(newInputValue), 1000);
                }}
                getOptionLabel={(option: any) => {
                  return option.name;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tests"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                className="input"
                name="start_date"
                type="date"
                label="Start Date"
                value={startDate}
                variant="outlined"
                onChange={(e) => setStartDate(e.target.value)}
                style={{ width: "100%" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                name="end_date"
                type="date"
                value={endDate}
                className="input"
                label="End Date"
                variant="outlined"
                onChange={(e) => setEndDate(e.target.value as string)}
                style={{ width: "100%" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="secondary"
                style={{ height: "56px" }}
                fullWidth
                type="submit"
                // onClick={filterHandler}
              >
                Submit
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() =>
                  history.push("/dashboard/gnadmin/centre_camp_package")
                }
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
        <div>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "540px" }}
          >
            {" "}
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">S. NO.</StyledTableCell>
                    <StyledTableCell align="center">Package</StyledTableCell>

                    <StyledTableCell align="center">Centres</StyledTableCell>
                    <StyledTableCell align="center">Valid From</StyledTableCell>
                    <StyledTableCell align="center">Valid Till</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {centreCampPackage.results &&
                    centreCampPackage.results.length > 0 &&
                    centreCampPackage.results.map((val: any, index: any) => {
                      return (
                        <StyledTableRow className={classes.tableRow}>
                          <StyledTableCell align="center">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {val?.package?.name}
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            {val?.centers &&
                              val?.centers.length > 0 &&
                              val?.centers.map((val: any, index1: any) => {
                                return val?.display_name !== null
                                  ? val?.display_name + ", "
                                  : val?.name + ", ";
                              })}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {moment(val?.valid_from).format("DD-MM-YYYY")}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {moment(val?.valid_till).format("DD-MM-YYYY")}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={centreCampPackage.count}
                  rowsPerPage={centreCampPackage.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </Table>
            )}
          </TableContainer>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  centreCampPackage: state.GenomicsAdminReducer.centreCampPackage,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  campPackages: state.GenomicsAdminReducer.campPackages,
  loading: state.GenomicsAdminReducer.loading,
});
export default connect(mapStateToProps, {
  getCenterInfo,
  getCentreCampPackage,
  postCentreCampPackage,
  updateCentreCampPackage,
  getCampPackages,
})(CentreCampPackage);
